import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";
import { useQuoteItems } from "../../../../../providers/quoteItemsProvider";
import { useQuoteRecap } from "../../../../../providers/quoteRecapProvider";
import { utils } from "../../../../../utils/utils";
import QuoteTotalEquipmentRentalSectionTotal from "./QuoteTotalEquipmentRentalSectionTotal";

const QuoteTotalEquipmentRentalSection = () => {
  const [quoteRecapContext] = useQuoteRecap();
  const [quoteItemsContext] = useQuoteItems();
  const [quoteItemEquipmentRentals, setQuoteItemEquipmentRentals] = useState(
    []
  );

  useEffect(() => {
    const quoteItemEquipmentRentals = utils.reduceQuoteItemsEquipmentRentals(
      quoteItemsContext.quoteItems
    );
    setQuoteItemEquipmentRentals(quoteItemEquipmentRentals);
  }, [quoteItemsContext]);

  return (
    <Table className="col-12 mt-4 px-0 border rounded mb-0">
      <tbody>
        {quoteItemEquipmentRentals.map((quoteItemEquipmentRental) => {
          const cost = quoteItemEquipmentRental.cost || 0;
          const sale = cost * (1 + quoteRecapContext.markupPercentage / 100);
          return (
            <tr key={quoteItemEquipmentRental.id}>
              <td className="py-0 text-truncate" width={"40%"}>
                {quoteItemEquipmentRental?.equipmentRental?.name}
              </td>
              <td className="py-0" width={"15%"} />
              <td className="py-0" width={"15%"}>
                <div readOnly className="form-control border text-right m-1">
                  {utils.formatCurrency(cost)}
                </div>
              </td>
              <td className="py-0" width={"15%"}>
                <div readOnly className="form-control border text-right m-1">
                  {utils.formatPercent(quoteRecapContext.markupPercentage, 100)}
                </div>
              </td>
              <td className="py-0" width={"15%"}>
                <div readOnly className="form-control border text-right m-1">
                  {utils.formatCurrency(sale)}
                </div>
              </td>
            </tr>
          );
        })}
        <QuoteTotalEquipmentRentalSectionTotal
          quoteItemEquipmentRentals={quoteItemEquipmentRentals}
        />
      </tbody>
    </Table>
  );
};

export default QuoteTotalEquipmentRentalSection;
